import { useApi } from '@/api';
import { Page, PageSkeleton } from '@/components';
import { CryptoIcon, Flex, Heading, useTableProps } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import TokenEventsTable from './TokenEventsTable';

export default function TokenActivityPage() {
  const { address } = useParams();
  const { pagination, sorting } = useTableProps({
    pageSize: 20,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });
  const [data, error] = useApi({
    url: `/tokens/${address}/events/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <Heading size="1">
            <Flex
              flexBasis="100%"
              gap={['xs', '2xs']}
              flexDirection={['column', 'row']}>
              <CryptoIcon name={data.symbol} address={address} size="3" />
              {data.symbol} Activity
            </Flex>
          </Heading>
        }>
        <TokenEventsTable
          data={data}
          sorting={sorting}
          pagination={pagination}
        />
      </Page>
    );
  }

  return <PageSkeleton />;
}
